import Paginate from "../paginate/Paginate";
import { invisibleQnaStyle } from "../navigation/temporay";
import RegisterLayer from "./RegisterLayer";
import throttle from "../../app/Helper/throttle";
import ReportLayer from "./ReportLayer";
import {
  getDeployPhase,
  showViewJsonStringCallApp,
} from "../../app/Helper/CommonHelper";

export default class QnaList {
  bAction = false; // 액션을 하고 있는지 아닌지 여부. bAction 이 true 인 동안에는 상품문의 api 호출을 막는다.

  constructor() {
    this.io = null;
    this.setPaginateOption();
    this.oRegisterLayer = new RegisterLayer();
    this.phase = "";
  }

  init() {
    // 환경 변수 값 가져오는 코드
    this.phase = getDeployPhase();

    if (this.bUsePaginate) {
      this.getQnaByPage(1);
    } else {
      this.getQna(true);
    }
  }

  update(sStorageKey) {
    switch (sStorageKey) {
      case "qnaList":
        if (!this.bWrapperRender) {
          this.bWrapperRender = true;
          this.render();
          this.setEvent();
          this.afterLoginAction();
        }
        this.setQna();
        this.updatePaginate();
        break;
      case "qnaAdd":
        this.cbQnaAdd();
        break;
      case "qnaModify":
        this.cbQnaModify();
        break;
      case "qnaDelete":
        this.cbQndDelete();
        break;
      case "qnaAddReply":
        this.cbQnaAddReply();
        break;
      case "qnaDeleteReply":
        this.cbQnaDeleteReply();
        break;
      case "qnaReport":
        this.cbQnaReport();
        break;
      default:
        break;
    }
  }

  setEvent() {
    $("#_qnaWrap").on("click", "[data-role=showReply]", (e) => {
      this.showReply(e);
    });
    $("#_qnaWrap").on("click", "#writeQnaButton", () => {
      this.onClickWriteQna();
    });
    $("#_qnaWrap").on("click", "[data-role=cancelQnaAdd]", () => {
      this.onClickCancelQnaAdd();
    });
    $("#_qnaWrap").on("submit", "[data-role=writeQnaForm]", (e) => {
      this.submitQnaAdd(e);
    });
    $("#_qnaWrap").on("click", "[data-role=modifyArticle]", (e) => {
      this.openQnaModify($(e.currentTarget).closest("._item"));
    });
    $("#_qnaWrap").on("click", "[data-role=deleteArticle]", (e) => {
      this.onClickQnaDelete(e);
    });
    $("#_qnaWrap").on("submit", "[data-role=modifyQnaForm]", (e) => {
      this.submitQnaModify(e);
    });
    $("#_qnaWrap").on("click", "[data-role=cancelQnaModify]", (e) => {
      this.onClickCancelQnaModify($(e.currentTarget).closest("._item"));
      e.preventDefault();
    });
    $("#_qnaWrap").on("click", "[data-role=addReply]", (e) => {
      this.onClickQnaAddReply(e);
    });
    $("#_qnaWrap").on("submit", "[data-role=addReplyQnaForm]", (e) => {
      this.submitQnaAddReply(e);
    });
    $("#_qnaWrap").on("click", "[data-role=replyDelete]", (e) => {
      this.onClickDeleteReply(e);
    });
    $("#_qnaWrap").on("click", "[data-role=cancelAddReply]", (e) => {
      this.onClickCancelAddReply($(e.currentTarget).closest("form"));
      e.preventDefault();
    });
    $("#_qnaWrap").on("focus", "textarea", (e) => {
      $(e.currentTarget)
        .siblings("label")
        .hide();
      if (TMON.oApp.sPlatform !== "PW") {
        setTimeout(() => {
          this.scrollToTextareaTop(e);
        }, 300);
      }
    });
    $("#_qnaWrap").on("blur", "textarea", (e) => {
      this.setTextareaPlaceholder(e);
    });
    $("#_qnaWrap").on("click", "[data-role=chkExcludeSecretQna]", () => {
      this.getQna(true);
    });
    $("#_qnaWrap").on("click", "[data-role=reportArticle]", (e) => {
      const sArticleSrl = $(e.currentTarget)
        .closest("li._item")
        .attr("data-articleSrl");
      this.openQnaReportLayer(sArticleSrl);
    });

    // 1:1 판매톡 클릭 이벤트
    $("#_qnaWrap").on("click", "[data-role=sellerTalkBtn]", (event) => {
      event.preventDefault();
      this.onClickSellerTalk();
      event.stopPropagation();
    });
  }

  clearEvent() {
    $("#_qnaWrap").off("click", "[data-role=showReply]");
    $("#_qnaWrap").off("click", "#writeQnaButton");
    $("#_qnaWrap").off("click", "[data-role=cancelQnaAdd]");
    $("#_qnaWrap").off("submit", "[data-role=writeQnaForm]");
    $("#_qnaWrap").off("click", "[data-role=modifyArticle]");
    $("#_qnaWrap").off("click", "[data-role=deleteArticle]");
    $("#_qnaWrap").off("submit", "[data-role=modifyQnaForm]");
    $("#_qnaWrap").off("click", "[data-role=cancelQnaModify]");
    $("#_qnaWrap").off("click", "[data-role=addReply]");
    $("#_qnaWrap").off("submit", "[data-role=addReplyQnaForm]");
    $("#_qnaWrap").off("click", "[data-role=replyDelete]");
    $("#_qnaWrap").off("click", "[data-role=cancelAddReply]");
    $("#_qnaWrap").off("focus", "textarea");
    $("#_qnaWrap").off("blur", "textarea");
    $("#_qnaWrap").off("click", "[data-role=reportArticle]");
    $("#_qnaWrap").off("click", "[data-role=sellerTalkBtn]");
  }

  setInfinityScroll() {
    const el = document.querySelector(".btn_qna_wrap");

    if (this.io && this.io.entryList) {
      this.io.unobserve(el);
      this.io = null;
    }

    const io = new TMON.IntersectionObserver((entry, observer) => {
      const display = document.querySelector("#qna-section").style.display;
      if (entry.isIntersecting && display !== "none") {
        const fn = throttle(() => {
          this.getQna();
          observer.unobserve(entry.target);
        }, 250);
        fn();
      }
    });

    io.observe(el);
  }

  afterLoginAction() {
    const sAfterLoginAction = localStorage.getItem("AFTER_LOGIN_QNA");
    const sQnaActionSerial = localStorage.getItem("QNA_ACTION_SERIAL");
    const nScroll = localStorage.getItem("QNA_ACTION_SCROLL");
    this.clearLocalStorage();
    if (!TMON.bLogin) {
      return;
    }
    switch (sAfterLoginAction) {
      case "QNA_ADD":
        this.openQnaAdd();
        TMON.oApp.oUtil.scrollTop(this, nScroll);
        break;
      case "QNA_ADD_REPLY":
        this.openQnaAddReply(sQnaActionSerial);
        TMON.oApp.oUtil.scrollTop(this, nScroll);
        break;
      case "QNA_REPORT":
        this.openQnaReportLayer(sQnaActionSerial);
        TMON.oApp.oUtil.scrollTop(this, nScroll);
        break;
      default:
        break;
    }
  }

  clearLocalStorage() {
    localStorage.removeItem("AFTER_LOGIN_QNA");
    localStorage.removeItem("QNA_ACTION_SERIAL");
    localStorage.removeItem("QNA_ACTION_SCROLL");
    localStorage.removeItem("qnaPage");
    localStorage.removeItem("qnaCount");
  }

  setPaginateOption() {
    if (TMON.oApp.sPlatform === "PW") {
      this.bUsePaginate = true;
    }
    if (this.bUsePaginate) {
      this.COUNT_PAGE_ON_BLOCK = 10;
      this.COUNT_PER_PAGE = 20;
      this.sPaginateId = "qnaPaginate";
    } else {
      this.FIRST_QNA_COUNT = 5; // 처음 호출할 QnA 카운트
      this.COUNT_PER_PAGE = 20;
      this.nPage = 0;
      this.nCount = 0;
    }
    this.bWrapperRender = false;
  }

  setQna() {
    this.nPage = TMON.oApp.htStorage.qnaList.callParam.params.page;
    this.nCount = TMON.oApp.htStorage.qnaList.callParam.params.count;
    const bReplaceData = this.nPage === 1 || this.bUsePaginate;
    this.renderItem(bReplaceData);
    this.toggleListUI();
  }

  getQna(bReset = false) {
    let nRequestPage = 0;
    let nRequestCount = 0;
    if (bReset) {
      // bReset 이 true 이므로, 현재 페이지를 무시하고 첫페이지를 불러옵니다.
      nRequestPage = 1;
      nRequestCount =
        TMON.oApp.htStorage.reviewType.data !== "N" &&
        TMON.oApp.sPlatform !== "PW"
          ? this.FIRST_QNA_COUNT
          : this.COUNT_PER_PAGE;
    } else if (this.nCount === this.FIRST_QNA_COUNT) {
      // FIRST_QNA_COUNT 와 현재 count 가 같으므로, page:1, count:COUNT_PER_PAGE 로 호출합니다.
      nRequestPage = 1;
      nRequestCount = this.COUNT_PER_PAGE;
    } else {
      // 위 상황에 모두 부합하지 않으면 다음 페이지를 불러와야 합니다.
      nRequestPage = this.nPage + 1;
      nRequestCount = this.COUNT_PER_PAGE;
    }

    const param = {
      page: nRequestPage,
      count: nRequestCount,
      flagSecret: $("[data-role=chkExcludeSecretQna]").is(":checked")
        ? "N"
        : "",
    };
    TMON.oApp.oApi.fetchApi("qnaList", param);
  }

  getQnaByPage(nRequestPage) {
    TMON.oApp.oApi.fetchApi("qnaList", {
      page: nRequestPage,
      count: this.COUNT_PER_PAGE,
      flagSecret: $("[data-role=chkExcludeSecretQna]").is(":checked")
        ? "N"
        : "",
    });
  }

  showReply(e) {
    if ($(e.currentTarget).attr("data-flagSecret") === "Y") {
      if (!TMON.bLogin) {
        if (
          window.confirm(
            "비밀글은 작성자만 확인 가능합니다. 로그인 후 확인해주세요."
          )
        ) {
          TMON.oApp.oUtil.login();
        } else {
          return;
        }
      } else if ($(e.currentTarget).attr("data-ownArticle") === "false") {
        window.alert("비밀글은 작성자만 확인 가능합니다.");
        return;
      }
    }

    const welShowReplyButton = $(e.currentTarget);
    if (parseInt(welShowReplyButton.attr("data-count"), 10) > 0) {
      welShowReplyButton.toggleClass("on");
      welShowReplyButton
        .closest("._item")
        .find(".reply_list")
        .toggle();
    }
  }

  toggleListUI() {
    const responseCount = TMON.oApp.htStorage.qnaList.data.talkList.length;
    const totalCount =
      TMON.oApp.htStorage.qnaList.data.totalCount +
      TMON.oApp.htStorage.qnaList.data.noticeCount;
    const nRenderedReviewCount = $("#_qnaList > li").length;

    if (nRenderedReviewCount < 1) {
      // 리스트가 비어있는 상황
      $("#_qnaWrap [data-role=empty]").removeClass("ct_empty");
      $("#_qnaWrap [data-role=list]").addClass("ct_empty");
      $("#_qnaWrap [data-role=button]").addClass("ct_empty");
    } else {
      // 리스트가 비어있지 않은 상황
      $("#_qnaWrap [data-role=empty]").addClass("ct_empty");
      $("#_qnaWrap [data-role=list]").removeClass("ct_empty");
      $("#_qnaWrap [data-role=button]").removeClass("ct_empty");
    }
    if (
      !this.bUsePaginate &&
      totalCount > nRenderedReviewCount &&
      responseCount !== 0
    ) {
      this.setInfinityScroll();
    }
  }

  setPagingToLocalStorage() {
    if (TMON.oApp.sPlatform !== "MA") {
      TMON.util.setHashJSON({ tab: TMON.oApp.htStorage.tab });
      localStorage.setItem("QNA_ACTION_SCROLL", $(window).scrollTop());
    }
  }

  onClickWriteQna() {
    if (!TMON.bLogin) {
      this.setPagingToLocalStorage();
      localStorage.setItem("AFTER_LOGIN_QNA", "QNA_ADD");
      TMON.oApp.oUtil.login();
    } else {
      this.openQnaAdd();
    }
  }

  openQnaAdd() {
    $("#_wrapQna").addClass("write");
    $("#_wrapQna [data-role=writeQnaForm] textarea").focus();
  }

  onClickCancelQnaAdd() {
    if ($("#_wrapQna [data-role=writeQnaForm] textarea").val().length > 0) {
      if (!confirm("상품문의 작성을 취소하시겠습니까?")) {
        return;
      }
    }
    this.cancelQnaAdd();
  }

  cancelQnaAdd() {
    $("#_wrapQna").removeClass("write");
    $("#_wrapQna [data-role=writeQnaForm]")[0].reset();
  }

  submitQnaAdd(e) {
    const welForm = $(e.currentTarget);
    const sAddText = welForm
      .find("textarea")
      .val()
      .replace(/(?:\r\n|\r|\n)/g, "<br>");
    const sFlagSecret = $('[data-role="chkSecretQnaAdd"]').is(":checked");
    if (this.bAction) {
      TMON.oApp.setStorage(
        "toast",
        "요청하신 작업을 처리중입니다. 잠시 후 다시 시도해 주십시오."
      );
      e.preventDefault();
      return;
    }
    if (sAddText.length === 0) {
      alert("작성된 문의 내용이 없습니다.");
      e.preventDefault();
      return;
    }
    TMON.oApp.oApi.fetchApi("qnaAdd", {
      content: encodeURIComponent(sAddText),
      flagSecret: sFlagSecret === true ? "Y" : "N",
    });
    e.preventDefault();
  }

  cbQnaAdd() {
    this.bAction = false;
    const { data } = TMON.oApp.htStorage.qnaAdd;
    if (TMON.oApp.htStorage.qnaAdd.httpCode !== 200) {
      const hasBannedWord =
        data.exceptionCode === "FIND_BANNED_WORD" ||
        data.exceptionCode === "ARTICLE_CONTENT_CONTAIN_EMOTICON";
      if (hasBannedWord) {
        // 금칙어가 있는 경우
        alert(data.exceptionMessage);
        return;
      }
      alert(
        "죄송합니다. 일시적인 서비스 오류이거나 로그인되지 않았습니다. 잠시 후 다시 시도해 주십시오."
      );
      return;
    }

    const { talkList } = data;
    const sHtml = this.getRenderedItem(talkList);
    const welQnaList = $("#_qnaList");
    if (welQnaList.find("[data-notice=true]").length > 0) {
      welQnaList.find("[data-notice=true]:last").after(sHtml);
    } else {
      welQnaList.prepend(sHtml);
    }
    this.cancelQnaAdd();
    this.toggleListUI();
    TMON.util.numberWithComma(
      $("#_qnaUserViewCount").html(
        parseInt(
          $("#_qnaUserViewCount")
            .html()
            .replace(/,/gi, ""),
          10
        ) + 1
      )
    );
    const date = new Date();
    const week = ["일", "월", "화", "수", "목", "금", "토"];
    const dayOfWeek = week[date.getDay()];
    const hour = date.getHours();
    const minute = date.getMinutes();
    if (
      dayOfWeek === "토" ||
      dayOfWeek === "일" ||
      hour < 9 ||
      hour > 18 ||
      (hour === 18 && minute > 0)
    ) {
      this.oRegisterLayer.open();
    }
  }

  setTextareaPlaceholder(e) {
    const welTargetTextarea = $(e.currentTarget);
    if (welTargetTextarea.val().length > 0) {
      welTargetTextarea.siblings("label").hide();
    } else {
      welTargetTextarea.siblings("label").show();
    }
  }

  replaceEntity(sString) {
    let refineString = "";
    refineString = sString.replace(/&amp;/g, "&");
    refineString = sString.replace(/&lt;/g, "<");
    refineString = sString.replace(/&gt;/g, ">");
    refineString = sString.replace(/&#39;/g, "'");
    refineString = sString.replace(/&quot;/g, '"');
    return refineString;
  }

  openQnaModify(welTargetItem) {
    if (welTargetItem.hasClass("edit")) {
      this.onClickCancelQnaModify(welTargetItem);
      return;
    }
    const sOriginalText = this.replaceEntity(
      welTargetItem
        .find(".qna_txt")
        .html()
        .replace(/<br>/g, "\n")
    );
    $("#_qnaWrap")
      .find("._item")
      .removeClass("edit");
    welTargetItem.addClass("edit");
    welTargetItem.find("._edit").val(sOriginalText);
  }

  onClickCancelQnaModify = (welTargetItem) => {
    const sOriginalText = welTargetItem
      .find(".qna_txt")
      .html()
      .replace(/<br>/g, "\n");
    const sEditText = welTargetItem.find("._edit").val();
    let bConfirm = false;
    if (sOriginalText !== sEditText) {
      bConfirm = true;
    }
    if (sEditText === "") {
      bConfirm = false;
    }
    if (bConfirm) {
      if (!confirm("상품문의 수정을 취소하시겠습니까?")) {
        return;
      }
    }

    this.cancelQnaModify(welTargetItem);
  };

  cancelQnaModify = (welTargetItem) => {
    const welForm = welTargetItem.find("form[data-role=modifyQnaForm]");
    welTargetItem.removeClass("edit");
    welForm.find("textarea").val(welTargetItem.find(".qna_txt").html());
  };

  submitQnaModify = (e) => {
    const welForm = $(e.currentTarget);
    const sAddText = welForm
      .find("textarea")
      .val()
      .replace(/(?:\r\n|\r|\n)/g, "<br>");
    const sFlagSecret = welForm
      .find("[data-role=chkSecretModify]")
      .is(":checked")
      ? "Y"
      : "N";
    if (this.bAction) {
      TMON.oApp.setStorage(
        "toast",
        "요청하신 작업을 처리중입니다. 잠시 후 다시 시도해 주십시오."
      );
      e.preventDefault();
      return;
    }
    if (sAddText.length === 0) {
      alert("작성된 문의 내용이 없습니다.");
      e.preventDefault();
      return;
    }
    this.bAction = true;
    TMON.oApp.oApi.fetchApi("qnaModify", {
      content: encodeURIComponent(sAddText),
      articleSrl: welForm.attr("data-articleSrl"),
      flagSecret: sFlagSecret,
    });
    e.preventDefault();
  };

  cbQnaModify = () => {
    this.bAction = false;
    const { data } = TMON.oApp.htStorage.qnaModify;
    if (TMON.oApp.htStorage.qnaModify.httpCode !== 200) {
      const hasBannedWord =
        data.exceptionCode === "FIND_BANNED_WORD" ||
        data.exceptionCode === "ARTICLE_CONTENT_CONTAIN_EMOTICON";
      if (hasBannedWord) {
        // 금칙어가 있는 경우
        alert(data.exceptionMessage);
        return;
      }
      alert(
        "죄송합니다. 일시적인 서비스 오류이거나 로그인되지 않았습니다. 잠시 후 다시 시도해 주십시오."
      );
      return;
    }

    const { articleSrl } = TMON.oApp.htStorage.qnaModify.callParam.params;
    const sRenderedItemHtml = this.getRenderedItem(data.talkList);
    $("#_qnaList")
      .find(`li._item[data-articleSrl=${articleSrl}]`)
      .replaceWith(sRenderedItemHtml);
  };

  onClickQnaDelete = (e) => {
    if (!confirm("상품문의를 삭제하시겠습니까?")) {
      e.preventDefault();
      return;
    }
    this.qnaDelete(e);
  };

  qnaDelete = (e) => {
    const sArticleSrl = $(e.currentTarget)
      .closest("li._item")
      .attr("data-articleSrl");
    if (this.bAction) {
      TMON.oApp.setStorage(
        "toast",
        "요청하신 작업을 처리중입니다. 잠시 후 다시 시도해 주십시오."
      );
      e.preventDefault();
      return;
    }
    this.bAction = true;
    TMON.oApp.oApi.fetchApi("qnaDelete", { articleSrl: sArticleSrl });
    e.preventDefault();
  };

  onClickQnaAddReply = (e) => {
    const sArticleSrl = $(e.currentTarget)
      .closest("li._item")
      .attr("data-articleSrl");
    const bSecret = $(e.currentTarget).attr("data-flagSecret");
    const bOwnArticle = $(e.currentTarget).attr("data-ownArticle");

    if (bSecret === "Y" && !TMON.bLogin) {
      if (confirm("비밀글은 작성자만 댓글 등록이 가능합니다.")) {
        TMON.oApp.oUtil.login();
      } else {
        return;
      }
    } else if (bSecret === "Y" && bOwnArticle === "false") {
      alert("비밀글은 작성자만 댓글 등록이 가능합니다.");
      return;
    }

    if (
      $(e.currentTarget)
        .closest("li")
        .find("[data-role=addReplyQnaForm]")
        .is(":visible")
    ) {
      this.onClickCancelAddReply(
        $(e.currentTarget)
          .closest("li")
          .find("[data-role=addReplyQnaForm]")
      );
      return;
    }
    if (TMON.oApp.sPlatform !== "PW") {
      $("#_qnaWrap").css("padding-bottom", "500px");
    }
    if (!TMON.bLogin) {
      this.setPagingToLocalStorage();
      localStorage.setItem("AFTER_LOGIN_QNA", "QNA_ADD_REPLY");
      localStorage.setItem("qnaPage", this.nPage);
      localStorage.setItem("qnaCount", this.nCount);
      localStorage.setItem("QNA_ACTION_SERIAL", sArticleSrl);
      TMON.oApp.oUtil.login();
    } else {
      this.openQnaAddReply(sArticleSrl);
    }
  };

  cbQndDelete = () => {
    if (TMON.oApp.htStorage.qnaDelete.httpCode !== 200) {
      alert(
        "죄송합니다. 일시적인 서비스 오류이거나 로그인되지 않았습니다. 잠시 후 다시 시도해 주십시오."
      );
      return;
    }
    const sArticleSrl =
      TMON.oApp.htStorage.qnaDelete.callParam.params.articleSrl;
    const welArticle = $("#_qnaList").find(
      `li._item[data-articleSrl=${sArticleSrl}]`
    );
    TMON.util.numberWithComma(
      $("#_qnaUserViewCount").html(
        parseInt(
          $("#_qnaUserViewCount")
            .html()
            .replace(/,/gi, ""),
          10
        ) - 1
      )
    );
    alert("상품문의가 삭제되었습니다.");
    welArticle
      .find("[data-role=articleContent]")
      .html("작성자에 의해 삭제된 내용입니다.");
    welArticle.find("[data-role=modifyArticle]").hide();
    welArticle.find("[data-role=deleteArticle]").hide();
    welArticle.find("[data-role=addReply]").hide();
    this.bAction = false;
  };

  openQnaAddReply = (sArticleSrl) => {
    $("#_qnaList")
      .find(`li._item[data-articleSrl=${sArticleSrl}]`)
      .addClass("write");
    $("#_qnaList")
      .find(
        `li._item[data-articleSrl=${sArticleSrl}] [data-role=addReplyQnaTextarea]`
      )
      .focus();
  };

  submitQnaAddReply = (e) => {
    const welForm = $(e.currentTarget);
    const sAddText = welForm
      .find("textarea")
      .val()
      .replace(/(?:\r\n|\r|\n)/g, "<br>");

    if (this.bAction) {
      TMON.oApp.setStorage(
        "toast",
        "요청하신 작업을 처리중입니다. 잠시 후 다시 시도해 주십시오."
      );
      e.preventDefault();
      return;
    }
    if (sAddText.length === 0) {
      alert("작성된 댓글 내용이 없습니다.");
      e.preventDefault();
      return;
    }
    this.bAction = true;
    this.nReplyActionArticleNo = welForm.attr("data-articleSrl");
    TMON.oApp.oApi.fetchApi("qnaAddReply", {
      content: encodeURIComponent(sAddText),
      articleSrl: this.nReplyActionArticleNo,
    });
    e.preventDefault();
  };

  cbQnaAddReply = () => {
    this.bAction = false;
    this.nReplyActionArticleNo = "";

    const { data } = TMON.oApp.htStorage.qnaAddReply;
    if (TMON.oApp.htStorage.qnaAddReply.httpCode !== 200) {
      const hasBannedWord =
        data.exceptionCode === "FIND_BANNED_WORD" ||
        data.exceptionCode === "ARTICLE_CONTENT_CONTAIN_EMOTICON";
      if (hasBannedWord) {
        // 금칙어가 있는 경우
        alert(data.exceptionMessage);
        return;
      }
      alert(
        "죄송합니다. 일시적인 서비스 오류이거나 로그인되지 않았습니다. 잠시 후 다시 시도해 주십시오."
      );
      return;
    }

    if (TMON.oApp.sPlatform !== "PW") {
      $("#_qnaWrap").css("padding-bottom", "0px");
    }

    const { articleSrl } = TMON.oApp.htStorage.qnaAddReply.callParam.params;
    const aReply = [];
    const welArticle = $("#_qnaList").find(
      `li._item[data-articlesrl=${articleSrl}]`
    );
    const nReplyCount = parseInt(
      welArticle.find("[data-role=replyCount]").html(),
      10
    );
    aReply.push(data);
    const sRenderedItemHtml = this.getArticleReply(aReply);
    welArticle.find("[data-role=reply_list]").append(sRenderedItemHtml);
    welArticle.find("[data-role=replyCount]").html(`${nReplyCount + 1}`);
    welArticle
      .find("[data-role=showReply]")
      .attr("data-count", `${nReplyCount + 1}`);
    this.cancelAddReply(welArticle.find("form[data-role=addReplyQnaForm]"));
  };

  onClickCancelAddReply = (welForm) => {
    if (
      welForm.find("textarea").val().length > 0 &&
      !confirm("댓글 작성을 취소하시겠습니까?")
    ) {
      return;
    }
    this.cancelAddReply(welForm);
  };

  cancelAddReply = (welForm) => {
    const welItem = welForm.closest("li._item");
    welItem.removeClass("write");
    if (TMON.oApp.sPlatform !== "PW") {
      $("#_qnaWrap").css("padding-bottom", "0px");
    }
    welItem.find("[data-role=addReplyQnaForm]")[0].reset();
  };

  onClickDeleteReply = (e) => {
    const sReplySrl = $(e.currentTarget)
      .closest("[data-role=qnaReply]")
      .attr("data-replySrl");
    if (!confirm("댓글을 삭제하시겠습니까?")) {
      e.preventDefault();
      return;
    }
    this.bAction = true;
    this.nReplyActionArticleNo = $(e.currentTarget)
      .closest("._item")
      .attr("data-articlesrl");
    TMON.oApp.oApi.fetchApi("qnaDeleteReply", { replySrl: sReplySrl });
    e.preventDefault();
  };

  cbQnaDeleteReply = () => {
    this.bAction = false;
    this.nReplyActionArticleNo = "";
    if (
      TMON.oApp.htStorage.qnaDeleteReply.httpCode !== 200 ||
      TMON.oApp.htStorage.qnaDeleteReply.data.result !== true
    ) {
      alert(
        "죄송합니다. 일시적인 서비스 오류이거나 로그인되지 않았습니다. 잠시 후 다시 시도해 주십시오."
      );
      return;
    }
    const sReplySrl = TMON.oApp.htStorage.qnaDeleteReply.htParams.replySrl;
    const welTargetReply = $("#_qnaList").find(
      `li[data-replySrl=${sReplySrl}]`
    );
    const sArticleSrl = welTargetReply
      .closest("li._item")
      .attr("data-articleSrl");
    const welArticle = $("#_qnaList").find(
      `li._item[data-articlesrl=${sArticleSrl}]`
    );
    const nReplyCount = parseInt(
      welArticle.find("[data-role=replyCount]").html(),
      10
    );
    alert("댓글이 삭제되었습니다.");
    welTargetReply.remove();
    welArticle.find("[data-role=replyCount]").html(`${nReplyCount - 1}`);
    welArticle
      .find("[data-role=showReply]")
      .attr("data-count", `${nReplyCount - 1}`);
    if (
      $("#_qnaList")
        .find(`li._item[data-articleSrl=${sArticleSrl}] [data-role=reply_list]`)
        .find("li").length === 0
    ) {
      $("#_qnaList")
        .find(`li._item[data-articleSrl=${sArticleSrl}] [data-role=showReply]`)
        .removeClass("on");
      $("#_qnaList")
        .find(`li._item[data-articleSrl=${sArticleSrl}] .reply_list`)
        .hide();
    }
  };

  // 신고하기 레이어 팝업
  openQnaReportLayer = (sArticleSrl) => {
    localStorage.setItem("QNA_ACTION_SERIAL", sArticleSrl);
    localStorage.setItem("AFTER_LOGIN_QNA", "QNA_REPORT");

    if (!TMON.bLogin) {
      this.setPagingToLocalStorage();
      TMON.oApp.oUtil.login("", "", "", this.afterLoginAction.bind(this));
    } else {
      if (!this.oReportLayer) {
        this.oReportLayer = new ReportLayer();
      }

      const { talkList } = TMON.oApp.htStorage.qnaList.data;
      const selectedQna = talkList.filter(
        (item) => item.aSrl === Number(sArticleSrl)
      );
      selectedQna.forEach((item) => {
        // 본인이 쓴 문의 글인 경우 팝업 미노출 & 알럿창
        if (item.ownArticle) {
          const container = document.getElementById("_layerContainer");
          container.remove();
          alert("자신의 문의는 신고할 수 없습니다.");
        }
      });

      this.oReportLayer.open(sArticleSrl, "qna");
      this.clearLocalStorage();
    }
  };

  cbQnaReport = () => {
    try {
      if (TMON.oApp.htStorage.qnaReport.data.result) {
        /**
         * 구글 심사 UGC 정책 위반 대응
         * 신고한 리뷰는 보이지 않도록 정리합니다.
         */
        alert(
          "신고해 주셔서 감사합니다.\n신고 내용은 이용약관 및 정책에 의해 처리됩니다."
        );
      } else {
        alert(TMON.oApp.htStorage.qnaReport.data.message);
      }
    } catch (e) {
      // console.error(e);
      alert("잘못된 요청입니다.");
    }
  };

  onClickSellerTalk = () => {
    const { partnerNo, dealNo } = TMON.htStaticData.htDealInfo;
    const moveUrl =
      this.phase === "release"
        ? `https://sellertalk.tmon.co.kr/chat/${partnerNo}?deal_srl=${dealNo}`
        : `https://sellertalk-${
            this.phase
          }.tmon.co.kr/chat/${partnerNo}?deal_srl=${dealNo}`;
    const isWebDevice = TMON.view_mode === "web";

    if (isWebDevice) {
      if (TMON.bLogin) {
        window.location.href = moveUrl;
      } else {
        // 로그인이 되어있지 않을 경우 로그인 페이지로 이동
        TMON.oApp.oUtil.login(moveUrl, "message=login_required");
      }
    } else if (TMON.app._isValidAppVersion("6.3.0")) {
      const showViewJsonStringParam = `{
        "title": "1:1 판매자톡",
        "url": "${moveUrl}",
        "modal": false,
        "needLogin": true,
        "needNavigation": false,
        "isCartShow": false,
        "isAlarmShow": false,
        "isParentReload": false,
        "isTabBarShow": true
      }`;
      showViewJsonStringCallApp(showViewJsonStringParam);
    } else {
      // 6.3.0 버전 이하 app 버전 사용자들은 기존 콜앱을 호출할 수 있도록 방어 코드
      TMON.app.callApp(
        "webview",
        "showView",
        "1:1 판매자톡",
        moveUrl,
        false,
        true,
        false
      );
    }
  };

  render() {
    const { userViewCount } = TMON.oApp.htStorage.qnaList.data;
    // https://jira.qoo10.it/browse/TM-13815 해당 이슈로 지입구 잠시 제거
    // const isDeliveryDeal =
    //   TMON.oApp.htStorage.htStaticData.htDealInfo.dealType === "DELIVERY";

    const sHtml = `
            <div class="qna_wrp" ${invisibleQnaStyle()}>
                <div class="review_tit" id="_wrapQna">
                    <h2>상품문의</h2>
                    <span class="count">총 <em id="_qnaUserViewCount">${TMON.util.numberWithComma(
                      userViewCount
                    )}</em>개</span>
                     ${
                       // https://jira.qoo10.it/browse/TM-13815 해당 이슈로 지입구 잠시 제거
                       //  TMON.oApp.sPlatform !== "PW" && isDeliveryDeal
                       //    ? `<span class="seller-contact">
                       //       <a data-role="sellerTalkBtn" href="#" class="c-button c-button--xxs c-button--secondary c-button--round">1:1 판매자톡</a>
                       //     </span>`
                       //    : ""
                       ""
                     } 
                    ${
                      TMON.oApp.sPlatform !== "PW"
                        ? `<ul class="review_info_list">
                          <li class="item">상품과 관계없는 글, 양도, 광고성, 욕설, 비방, 도배 등의 글은 예고없이 삭제됩니다.</li>
                          <li class="item">개인정보보호를 위해 상품문의에 개인정보를 입력하지 말아주세요.</li>
                        </ul>`
                        : ""
                    }
                    <button type="button" class="btn_qna_write" id="writeQnaButton" data-tlarea="PCI2" data-tlord="1" style="${
                      TMON.oApp.sPlatform === "PW" && TMON.bLogin
                        ? "display:none"
                        : ""
                    }"><span>상품 문의하기</span></button>
                    ${
                      TMON.oApp.sPlatform === "PW"
                        ? `<div class="reply_notice">
                            <ul class="review_info_list">
                              <li class="item">상품과 관계없는 글, 양도, 광고성, 욕설, 비방, 도배 등의 글은 예고없이 삭제됩니다.</li>
                              <li class="item">개인정보보호를 위해 상품문의에 개인정보를 입력하지 말아주세요.</li>
                            </ul>
                            <div class="btn_area">
                                <a href="${
                                  TMON.htLocal.htURL.help
                                }" class="btn btn_sm gray" data-tlarea="PCI8" data-tlord="2">자주 묻는 질문 바로가기</a>
                            </div>
                        </div>`
                        : ""
                    }
                    <div id="wrtieQnaArea" class="reply_write write">
                        <form data-role="writeQnaForm" action="#tab=review">
                            ${
                              TMON.oApp.sPlatform === "PW"
                                ? '<div class="wrt_area"><textarea cols="30" rows="10" title="문의 작성" id="qnaTextarea"></textarea><label for="qnaTextarea">상품에 대해 궁금한 점을 물어보세요.</label></div>'
                                : '<textarea cols="30" rows="10" title="문의 작성" id="qnaTextarea" placeholder="상품에 대해 궁금한 점을 물어보세요."></textarea>'
                            }
                            ${
                              TMON.oApp.sPlatform !== "PW"
                                ? `<div class="chk_area">
                                <label class="chk_box">
                                    <!-- TWORK-10471 티몬 전체딜 문의글 비밀글로 제한 -->
                                    <!-- <input data-tlarea="PCI6" data-tlord="1" type="checkbox" data-role="chkSecretQnaAdd"> -->
                                    <input data-tlarea="PCI6" data-tlord="1" type="checkbox" data-role="chkSecretQnaAdd" checked onClick="return false;">
                                    <i class="ico"></i>
                                    <em>비밀글로 문의하기</em>
                                </label>
                            </div>`
                                : ""
                            }
                            <ul class="btn_area col2">
                                <li>
                                    <button type="button" class="btn_reply cancel" data-role="cancelQnaAdd" data-tlarea="PCI2" data-tlord="3">취소하기</button>
                                </li>
                                <li>
                                    <button type="submit" class="btn_reply add" data-role="submitWriteQna" data-tlarea="PCI2" data-tlord="2">등록하기</button>
                                </li>
                            </ul>
                            ${
                              TMON.oApp.sPlatform === "PW"
                                ? `<div class="chk_area">
                                <label class="chk_box">
                                    <!-- TWORK-10471 티몬 전체딜 문의글 비밀글로 제한 -->
                                    <!-- <input data-tlarea="PCI6" data-tlord="1" type="checkbox" data-role="chkSecretQnaAdd"> -->
                                    <input data-tlarea="PCI6" data-tlord="1" type="checkbox" data-role="chkSecretQnaAdd" checked onClick="return false;">
                                    <i class="ico"></i>
                                    <em>비밀글로 문의하기</em>
                                </label>
                            </div>`
                                : ""
                            }
                        </form>
                    </div>
                </div>
                ${
                  TMON.oApp.sPlatform !== "PW"
                    ? `<div class="_qnaTitle review_tit">
                        <h2>문의 전체</h2>
                        <div class="chk_area">
                            <label for="_scretNoView" class="chㄴk_box">
                                <input type="checkbox" id="_scretNoView"  data-role="chkExcludeSecretQna" data-tlarea="PCI6" data-tlord="1" >
                                <i class="ico"></i>
                                <em>비밀글 제외</em>
                            </label>
                        </div>
                    </div>`
                    : ""
                }
                <div class="bx_ct">
                    ${
                      TMON.oApp.sPlatform === "PW"
                        ? `<div class="ct_wrp top_info_wrap">
                            <ul class="member_info">
                                <li>
                                    <span class="customer">
                                        <span class="ico">구매</span>
                                        <span class="txt">구매회원</span>
                                    </span>
                                </li>
                                <li>
                                    <span class="normal">
                                        <span class="ico">비구매</span>
                                        <span class="txt">비구매회원</span>
                                    </span>
                                </li>
                                <li>
                                    <span class="seller">
                                        <span class="ico">판매자</span>
                                        <span class="txt">상품 판매자</span>
                                    </span>
                                </li>
                                <li>
                                    <span class="tmon">
                                        <span class="ico">티몬</span>
                                        <span class="txt">티몬 담당자</span>
                                    </span>
                                </li>
                            </ul>
                            <div class="chk_area">
                                <label class="chk_box">
                                    <input data-tlarea="PCI6" data-tlord="1" type="checkbox" data-role="chkExcludeSecretQna">
                                    <i class="ico"></i>
                                    <em>비밀글 제외</em>
                                </label>
                            </div>
                        </div>`
                        : ""
                    }
                    <div data-role="empty" class="ct_wrp">
                        <div class="no_ct_txt"><p class="btn_write_go">등록된 상품 문의 글이 없습니다.<span>상품에 대해 궁금한 점을 남겨주세요.</span></p>
                        </div>
                    </div>
                    <div data-role="list" class="ct_wrp">
                        <ul id="_qnaList" class="qna_lst"></ul>
                    </div>
                    ${
                      this.bUsePaginate === true
                        ? `<div class="ct_wrp" data-role="paginate-wrap" id="${
                            this.sPaginateId
                          }"></div>`
                        : `<div data-role="button" class="ct_wrp">
                            <div class="btn_area btn_qna_wrap"></div>
                        </div>`
                    }
                </div>
            </div>
        `;
    $("#_qnaWrap").html(sHtml);
    if (this.bUsePaginate) {
      this.initPaginate();
    }
  }

  renderItem(bReplaceData) {
    const { noticeList } = TMON.oApp.htStorage.qnaList.data;
    const { talkList } = TMON.oApp.htStorage.qnaList.data;

    const renderList = talkList;
    if (bReplaceData && noticeList[0]) {
      renderList.unshift(noticeList[0]);
    }

    if (renderList.length < 1 && $("#_scretNoView").is(":checked") === false) {
      $("._qnaTitle").hide();
    }

    const sHtml = this.getRenderedItem(renderList);

    if (bReplaceData) {
      $("#_qnaList").html(sHtml);
    } else {
      $("#_qnaList").append(sHtml);
    }
  }

  getRenderedItem(renderList) {
    return renderList
      .map(
        (item) => `
                <li class="_item ${
                  item.ownArticle ? "crnt_user" : ""
                }" data-articleSrl="${item.aSrl}" ${
          item.iconType === "NOTICE" ? 'data-notice="true"' : ""
        }>
                    <div class="member_info">
                        ${
                          item.iconType === "NOTICE"
                            ? '<span class="user notice"><span class="ico">공지</span>'
                            : ""
                        }
                        ${
                          item.iconType === "NORMAL"
                            ? '<span class="user normal"><span class="ico">비구매</span>'
                            : ""
                        }
                        ${
                          item.iconType === "BUYER"
                            ? '<span class="user customer"><span class="ico">구매</span>'
                            : ""
                        }
                        ${
                          item.iconType === "TMON"
                            ? '<span class="user tmon"><span class="ico">티몬</span>'
                            : ""
                        }
                        ${
                          item.iconType === "CS"
                            ? '<span class="user cs"><span class="ico">고객센터</span>'
                            : ""
                        }
                        ${
                          item.iconType === "SELLER"
                            ? '<span class="user seller"><span class="ico">판매자</span>'
                            : ""
                        }
                        ${
                          item.iconType !== "TMON" &&
                          item.iconType !== "CS" &&
                          item.iconType !== "SELLER" &&
                          item.mId
                            ? `<span class="id">${item.mId}</span>`
                            : ""
                        }<span class="date">${item.createDt}</span>
                        <span class="btn">
                          ${
                            // 신고 버튼 : 본인이 작성한 문의글 외에는 모두 신고 버튼 노출되어야 함
                            TMON.oApp.sPlatform === "PW" &&
                            !item.ownArticle &&
                            item.flagSecret === "N"
                              ? this.getReportButton()
                              : ""
                          }
                          ${
                            item.iconType !== "NOTICE" &&
                            TMON.oApp.sPlatform === "PW"
                              ? this.getUtilButtons(item)
                              : ""
                          }
                        </span>
                    </div>
                    <div class="txt_area"><p class="qna_txt ${
                      item.flagSecret === "Y" ? "secret" : ""
                    }" data-role="articleContent">${item.content
          .replace(/(?:\r)/g, "")
          .replace(/(?:\r\n|\r|\n)/g, "<br>")}</p></div>
                    <div class="reply_area">
                        <form data-role="modifyQnaForm" method="get" action="#tab=review" data-articleSrl="${
                          item.aSrl
                        }">
                            <div class="reply_write edit"><textarea class="_edit" cols="30" rows="10" title="댓글 수정">${item.content.replace(
                              /<br>/g,
                              "\n"
                            )}</textarea>
                                <div class="chk_area">
                                    <label class="chk_box">
                                        <input type="checkbox" data-role="chkSecretModify" ${
                                          item.flagSecret === "Y"
                                            ? "checked"
                                            : ""
                                        }>
                                        <i class="ico"></i>
                                        <em>비밀글</em>
                                    </label>
                                </div>
                                <ul class="btn_area col2">
                                    <li>
                                        <button type="button" class="btn_reply cancel" data-tlarea="PCI4" data-tlord="3" data-role="cancelQnaModify">취소하기</button>
                                    </li>
                                    <li>
                                        <button type="submit" class="btn_reply write" data-tlarea="PCI4" data-tlord="2">수정하기</button>
                                    </li>
                                </ul>
                            </div>
                        </form>
                        ${
                          item.iconType !== "NOTICE"
                            ? `<div class="reply_util">
                                <button type="button" class="count" data-tlarea="PCI3" data-tlord="1" data-role="showReply" data-count="${
                                  item.replyCount
                                }" data-flagSecret="${
                                item.flagSecret
                              }" data-ownArticle="${
                                item.ownArticle
                              }">댓글보기 <em data-role="replyCount">${
                                item.replyCount
                              }</em></button>
                                ${
                                  // 신고 버튼 : 본인이 작성한 문의글 외에는 모두 신고 버튼 노출되어야 함 item.flagSecret === 'Y'
                                  TMON.oApp.sPlatform !== "PW" &&
                                  !item.ownArticle &&
                                  item.flagSecret === "N"
                                    ? this.getReportButton()
                                    : ""
                                }
                                ${
                                  TMON.oApp.sPlatform !== "PW"
                                    ? this.getUtilButtons(item)
                                    : ""
                                }
                                ${
                                  item.flagView
                                    ? `<button type="button" class="btn_reply write" data-tlarea="PCI6" data-tlord="1" data-role="addReply" data-flagSecret="${
                                        item.flagSecret
                                      }" data-ownArticle="${
                                        item.ownArticle
                                      }">댓글</button>`
                                    : ""
                                }
                            </div>`
                            : ""
                        }
                        <div class="reply_write write">
                            <form data-role="addReplyQnaForm" method="get" action="#tab=review" data-articleSrl="${
                              item.aSrl
                            }">
                                <textarea cols="30" rows="10" title="댓글 작성" data-role="addReplyQnaTextarea"></textarea>
                                    <ul class="btn_area col2">
                                        <li>
                                            <button type="button" class="btn_reply cancel" data-tlarea="PCI6" data-tlord="3" data-role="cancelAddReply">취소하기</button>
                                        </li>
                                        <li>
                                            <button type="submit" class="btn_reply write" data-tlarea="PCI6" data-tlord="2">댓글달기</button>
                                        </li>
                                    </ul>
                                </form>
                        </div>
                        <div class="reply_list" style="display:none">
                            <ul data-role="reply_list">
                                ${
                                  item.replies && item.replies.length > 0
                                    ? this.getArticleReply(item.replies)
                                    : ""
                                }
                            </ul>
                        </div>
                    </div>
                </li>
            `
      )
      .join("");
  }

  getUtilButtons(item) {
    return item.flagView && item.ownArticle
      ? '<button type="button" class="btn_reply edit" data-role="modifyArticle" data-tlarea="PCI4" data-tlord="1"><span class="status_normal">수정</span><span class="status_modify">수정 취소</span></button> <button type="button" class="btn_reply del" data-role="deleteArticle" data-tlarea="PCI5" data-tlord="1">삭제</button>'
      : "";
  }

  getReportButton() {
    return '<button type="button" class="btn_reply report" data-role="reportArticle" data-tlarea="PCI6" data-tlord="1">신고</button>';
  }

  getArticleReply = (item) => {
    const sHtml = `
            ${item
              .map(
                (repliesItem) => `
                <li data-role="qnaReply" data-replySrl="${
                  repliesItem.replySrl
                }">
                    <div class="member_info">
                        ${
                          repliesItem.iconType === "NOTICE"
                            ? '<span class="user notice"><span class="ico">공지</span>'
                            : ""
                        }
                        ${
                          repliesItem.iconType === "NORMAL"
                            ? '<span class="user normal"><span class="ico">비구매</span>'
                            : ""
                        }
                        ${
                          repliesItem.iconType === "BUYER"
                            ? '<span class="user customer"><span class="ico">구매</span>'
                            : ""
                        }
                        ${
                          repliesItem.iconType === "TMON"
                            ? '<span class="user tmon"><span class="ico">티몬</span>'
                            : ""
                        }
                        ${
                          repliesItem.iconType === "CS"
                            ? '<span class="user cs"><span class="ico">고객센터</span>'
                            : ""
                        }
                        ${
                          repliesItem.iconType === "SELLER"
                            ? '<span class="user seller"><span class="ico">판매자</span>'
                            : ""
                        }
                        ${
                          repliesItem.iconType !== "TMON" &&
                          repliesItem.iconType !== "CS" &&
                          repliesItem.iconType !== "SELLER" &&
                          repliesItem.mId
                            ? `<span class="id">${repliesItem.mId}</span>`
                            : ""
                        }
                        <span class="date">${repliesItem.createDt}</span>
                        ${
                          repliesItem.ownArticle && repliesItem.flagView
                            ? '<button type="button" class="btn_del" data-role="replyDelete">삭제</button>'
                            : ""
                        }
                     </div>
                     <div class="txt_area"><p class="qna_txt ${
                       repliesItem.flagSecret === "Y" ? "secret" : ""
                     }">${repliesItem.content.replace(
                  /(?:\r\n|\r|\n)/g,
                  "<br>"
                )}</p></div>
                </li>
            `
              )
              .join("")}
        `;
    return sHtml;
  };

  initPaginate = () => {
    this.oPaginate = new Paginate({
      welPaginate: $(`#${this.sPaginateId}`),
      sTlcode: "PCIQBT",
    });
    this.oPaginate.init({
      onClickNumber: (e) => {
        this.getQnaByPage($(e.currentTarget).attr("data-num"));
        window.scrollTo(
          0,
          $("#qna-section").offset().top - $(".tab-navigation").height()
        );
        e.preventDefault();
      },
    });
  };

  updatePaginate = () => {
    if (this.oPaginate) {
      this.oPaginate.update({
        nPageOnBlock: this.COUNT_PAGE_ON_BLOCK,
        nActivatePage: parseInt(
          TMON.oApp.htStorage.qnaList.callParam.params.page,
          10
        ),
        nTotalArticle: parseInt(
          TMON.oApp.htStorage.qnaList.data.totalCount,
          10
        ),
        nArticleOnPage: this.COUNT_PER_PAGE,
      });
    }
  };

  scrollToTextareaTop = (e) => {
    const nHeaderHeight = TMON.util.gup("headerHeight")
      ? parseInt(TMON.util.gup("headerHeight"), 10)
      : $("header:first").outerHeight();
    const nTabNavigationHeight = $("#tab-navigation").outerHeight();
    const nTopNavigationAreaHeight = nHeaderHeight + nTabNavigationHeight;
    TMON.oApp.oUtil.scrollTop(
      this,
      $(e.currentTarget).offset().top - nTopNavigationAreaHeight - 10
    );
  };
}
